import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapeCavernas');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryShapeCavernas = () => 
  axios.get(urlAPI + "/all/" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeCavernasInsideByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeCavernasIntersectsByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeCavernasInsideByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeCavernasIntersectsByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

